/** Calendar/list label: "Main: Variant" when variant exists, otherwise main only. */
export function formatShowLabel(
  mainName: string | undefined | null,
  variantName?: string | undefined | null
): string {
  const main = (mainName ?? "").trim();
  const variant = (variantName ?? "").trim();
  if (variant) {
    return main ? `${main}: ${variant}` : variant;
  }
  return main;
}
